module.exports = __webpack_public_path__ + "img/progress_bar_goals.dae83d24.png";